import { AuthService } from '@lumora/common';
import { useContext } from 'react';

import { AuthServiceContext } from '../contexts/AuthServiceContextDefinition';

/**
 * Hook to access AuthService from context
 * @throws Error if used outside of AuthServiceProvider
 */
export function useAuthService(): AuthService {
  const context = useContext(AuthServiceContext);
  if (!context) {
    throw new Error(
      'useAuthService must be used within an AuthServiceProvider'
    );
  }
  return context;
}
